module.exports = __webpack_public_path__ + "static/img/9.f6f73dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/9.png
// module id = ZS/O
// module chunks = 0